import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';


@Component({
    selector: 'app-order-view-dialog',
    templateUrl: './order-view-dialog.component.html',
    styleUrls: ['./order-view-dialog.component.scss'],
    standalone: false
})
export class OrderViewDialogComponent {
	$storage: any;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<OrderViewDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.$storage = this.data.$storage;
	}
	cancel() {
		this.dialogRef.close();
	}

}
